module.exports = __webpack_public_path__ + "img/nt114-00-81-1.asm.ce6940f0.jpg";